// https://govuk-static.herokuapp.com/component-guide/document_footer
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import UnorderedList from '@govuk-react/unordered-list';
import { NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledContainer = styled('div')({
  fontFamily: NTA_LIGHT
});
var StyledDefinition = styled('li')({
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: 1.25,
  '> a': {
    textDecoration: 'none'
  }
});

var DocumentFooterMetadata = function DocumentFooterMetadata(_ref) {
  var from = _ref.from,
      partOf = _ref.partOf,
      other = _ref.other;
  var fromData = React.createElement(StyledContainer, null, from && React.createElement("div", null, React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "From:"), React.createElement(UnorderedList, {
    listStyleType: "none"
  }, from && from.map(function (child, i) {
    return (
      /* eslint-disable react/no-array-index-key */
      React.createElement(StyledDefinition, {
        key: i
      }, child)
      /* eslint-enable react/no-array-index-key */

    );
  }))));
  var partOfData = React.createElement(StyledContainer, null, partOf && React.createElement("div", null, React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Part of:"), React.createElement(UnorderedList, {
    listStyleType: "none"
  }, partOf && partOf.map(function (child, i) {
    return React.createElement(StyledDefinition, {
      key: child.key || i
    }, child);
  }))));
  var otherData = React.createElement(StyledContainer, null, other && other.map(function (item) {
    return React.createElement("div", {
      key: item.id
    }, React.createElement("p", {
      style: {
        marginBottom: 0
      }
    }, item.title, ":"), React.createElement(UnorderedList, {
      listStyleType: "none"
    }, React.createElement(StyledDefinition, null, item.content)));
  }));
  return React.createElement("div", null, fromData, partOfData, otherData);
};

DocumentFooterMetadata.defaultProps = {
  from: undefined,
  partOf: undefined,
  other: undefined
};
DocumentFooterMetadata.propTypes = process.env.NODE_ENV !== "production" ? {
  from: PropTypes.arrayOf(PropTypes.node),
  partOf: PropTypes.arrayOf(PropTypes.node),
  other: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    content: PropTypes.node
  }))
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(DocumentFooterMetadata);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/document-footer-metadata/es/index.js
// module id = 96
// module chunks = 0